import { DateTime } from "luxon";
import { z } from "zod/v4-mini";

import { TandemConstants } from "@/lib/drivers/tandem/TandemConstants";
import { TandemCommand, TandemResponse } from "@/lib/drivers/tandem/TandemTypes";
import { Schema } from "@/utils/zodUtils";

export type VersionPayload = {
  arm_sw_ver: string;
  msp_sw_ver: string;
  pump_sn: number;
  pump_part_no: number;
  pump_rev: string;
  pcba_sn: number;
  pcba_rev: string;
  model_no: number;
  timestamp: number;
};

export type TandemVersionInfo = {
  deviceModel: string;
  pumpSerial: number;
  firmwareVersion: number;
  cgmCapable: boolean;
  timestamp: DateTime;
};

export const versionPayloadSchema: Schema<VersionPayload> = z.object({
  arm_sw_ver: z.string(),
  model_no: z.number(),
  msp_sw_ver: z.string(),
  pcba_rev: z.string(),
  pcba_sn: z.number(),
  pump_part_no: z.number(),
  pump_rev: z.string(),
  pump_sn: z.number(),
  timestamp: z.number(),
});

export const VERSION_RESPONSE = {
  value: 81,
  name: "Version Message",
  version: 36102,
  format: "16Z16Z20.ii8Zi....8Z50.iI",
  fields: [
    "arm_sw_ver",
    "msp_sw_ver",
    "pump_sn",
    "pump_part_no",
    "pump_rev",
    "pcba_sn",
    "pcba_rev",
    "model_no",
    "timestamp",
  ] as const,
  postprocess: rec => ({
    deviceModel: rec.model_no.toString(),
    pumpSerial: rec.pump_sn,
    firmwareVersion: parseInt(rec.arm_sw_ver),
    cgmCapable: parseInt(rec.arm_sw_ver) >= 51000,
    timestamp: DateTime.fromSeconds(TandemConstants.BASE_TIME + rec.timestamp),
  }),
  schema: versionPayloadSchema,
} as const satisfies TandemResponse<VersionPayload, TandemVersionInfo>;

export const VERSION_COMMAND = {
  value: 82,
  name: "Version Request",
  version: 36102,
  response: VERSION_RESPONSE,
} as const satisfies TandemCommand<VersionPayload, TandemVersionInfo>;
